import { IDelivery } from '@data/hooks/use-delivery/delivery.types'

export function removeDuplicateDeliveries(
  deliveriesList: IDelivery[]
): IDelivery[] {
  const setDeliveries = new Set()
  return deliveriesList.filter((deliv) => {
    const duplicatedDelivery = setDeliveries.has(deliv.id)
    setDeliveries.add(deliv.id)
    return !duplicatedDelivery
  })
}
